import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import TimelineIcon from '@mui/icons-material/Timeline';
import BusinessIcon from '@mui/icons-material/Business';
import SchoolIcon from '@mui/icons-material/School';
import FlightIcon from '@mui/icons-material/Flight';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import WorkIcon from '@mui/icons-material/Work';
import ChildCareIcon from '@mui/icons-material/ChildCare';
import SecurityIcon from '@mui/icons-material/Security';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import PublicIcon from '@mui/icons-material/Public';

export const benefitIcons = {
  check: CheckCircleIcon,
  timeline: TimelineIcon,
  business: BusinessIcon,
  school: SchoolIcon,
  flight: FlightIcon,
  family: FamilyRestroomIcon,
  work: WorkIcon,
  childcare: ChildCareIcon,
  security: SecurityIcon,
  banking: AccountBalanceIcon,
  achievement: EmojiEventsIcon,
  global: PublicIcon,
};

export type BenefitIconType = keyof typeof benefitIcons;

export const getBenefitIcon = (type: BenefitIconType) => {
  const Icon = benefitIcons[type];
  return <Icon />;
}; 